export const GOOGLE_SHEETS_BASE_URL =
  "https://docs.google.com/spreadsheets/d/1RWMcojWSLCeHqprNNSDo97FK_k8qIj8erJyYwtpY3yw/gviz/tq?tqx=out:csv";

export const SHEET_TAB_NAMES = {
  matchups: "matchups",
  countries: "countries",
  rows: "rows",
  pricepool: "pricepool",
} as const;

export const REQUIRED_SHEET_TABS = [
  SHEET_TAB_NAMES.matchups,
  SHEET_TAB_NAMES.countries,
  SHEET_TAB_NAMES.rows,
  SHEET_TAB_NAMES.pricepool,
] as const;

export const SELECTED_USER_STORAGE_KEY = "user";
export const ACTIVE_VIEW_STORAGE_KEY = "activeView";
export const HIDE_RESOLVED_STORAGE_KEY = "hideResolved";
export const WINNERS_SORT_STORAGE_KEY = "winnersSort";
export const OVERVIEW_SORT_STORAGE_KEY = "overviewSort";

export const TOURNAMENT_NAME = "FIFA World Cup 2026";

export const DEFAULT_REVEAL_TIMESTAMP = "2026-06-11T19:00:00Z";

export const NUMERIC_MATCHUP_SHEET_FIELDS = [
  "oddsHome",
  "oddsDraw",
  "oddsAway",
  "multiplier",
] as const;

export const DATE_MATCHUP_SHEET_FIELD = "date";

export const ROW_ORDER_FIELD = "index";

export const WINNER_LOTTERY_ENTRY_FEE_EUR = 20;

export const POLYMARKET_EMBED_BASE_URL =
  "https://embed.polymarket.com/market";
export const POLYMARKET_GAMMA_MARKETS_URL =
  "https://gamma-api.polymarket.com/markets";
export const POLYMARKET_ODDS_REFRESH_MS = 60000;

export const appConfig = {
  tournamentName: TOURNAMENT_NAME,
  defaultRevealTimestamp: DEFAULT_REVEAL_TIMESTAMP,
  googleSheetsBaseUrl: GOOGLE_SHEETS_BASE_URL,
  sheetTabs: SHEET_TAB_NAMES,
  requiredSheetTabs: REQUIRED_SHEET_TABS,
  selectedUserStorageKey: SELECTED_USER_STORAGE_KEY,
  activeViewStorageKey: ACTIVE_VIEW_STORAGE_KEY,
  hideResolvedStorageKey: HIDE_RESOLVED_STORAGE_KEY,
  winnersSortStorageKey: WINNERS_SORT_STORAGE_KEY,
  overviewSortStorageKey: OVERVIEW_SORT_STORAGE_KEY,
  parserFields: {
    numeric: NUMERIC_MATCHUP_SHEET_FIELDS,
    date: DATE_MATCHUP_SHEET_FIELD,
    rowOrder: ROW_ORDER_FIELD,
  },
  winnerLotteryEntryFeeEur: WINNER_LOTTERY_ENTRY_FEE_EUR,
  polymarket: {
    embedBaseUrl: POLYMARKET_EMBED_BASE_URL,
    gammaMarketsUrl: POLYMARKET_GAMMA_MARKETS_URL,
    oddsRefreshMs: POLYMARKET_ODDS_REFRESH_MS,
  },
} as const;
